import styled from "styled-components";
import { toAbsoluteUrl } from "../../../utils/assetHelper";

export const AboutHeader = styled.div`
margin-top: 20px;
h1{
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 16px;
    text-align: center;
    color: #fff;

    @media screen and (max-width: 1100px) {
        font-size: 36px;
    }

    span{
        color: var(--primary-color);
    }
}
`

export const Wrapper = styled.div`
.contact-container{
background: url(${toAbsoluteUrl('/media/assay/contact.png')}) no-repeat;
background-position: 0 center;
background-size: cover;
margin-bottom: 48px;
@media screen and (max-width:1100px) {
background-position: left bottom;
margin-bottom: 24px;
}
}

.bio-container{
background: url(${toAbsoluteUrl('/media/assay/header1.png')}) no-repeat;
background-size: cover;
background-position: bottom center;

@media screen and (max-width:1100px) {
background-position: left bottom;
}
}

`

export const AssaySubHeader = styled.div`
margin-top: 35px;
margin-bottom: 48px;

 .subhero-img{
 width:60%;
 margin: 0 auto;

img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media screen and (max-width:1100px) {
    width: 90%; 
}
}
`

export const AssayContent = styled.div`
    width: 98vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 48px;
    margin-bottom: 48px;

    @media screen and (max-width:1100px) {
        margin-bottom: 24px;
    }

h2 {
font-size: 36px;
 font-weight: 800;
 line-height: 45px;
 text-align: center;

 span {
    background:linear-gradient(227deg, #DC4405 0%, #FF8D24 85.6%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    }

@media screen  and (max-width:1100px) {
    font-size: 24px;
}
}

.header-card-container{
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 960px;
    margin: 0 auto;

.card{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: #FFF2E5;
    padding: 44px 96px;
    font-size: #1e1e1e;
    font-size: 20px;
    font-weight: 500;
    text-align: center;

    @media screen and (max-width: 1100px)  {
        padding: 24px;
    }
}

@media screen and (max-width: 1100px) {
    width: 98%;
}
}

.antibodies-card-container{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    align-items: center;

    @media screen and (max-width: 1300px) {
        grid-template-columns: 1fr;
    }

.antibody-card{
display: flex;
flex-direction: column;
gap: 32px;

.text-card{
    background: #F1EEFC;
    padding: 32px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    h4, p{
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
        text-align: center;
        color: #1e1e1e;
        span {
            font-weight: 700;
        }
    }
}

img {
width: 100%;
object-fit: cover;

@media screen and (max-width: 1300px) {
        width: 50%;
        margin: 0 auto;
    }
}
}

}

`

export const ServiceStepsContainer = styled.div`
width: 98vw;
margin: 0 auto;
margin-bottom: 48px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 48px;
`

export const CardContainer = styled.div`
background: ${props => props.background || "#F1EEFC"};
color: ${props => props.textColor || "#1E1E1E"};
display: flex;
flex-direction: column;
justify-content: ${props => props.justifyContent || "center"};
padding: ${props => props.padding || "32px"};
border-radius: 20px;
width: ${props => props.width || "100%"};
margin: 0 auto;

@media screen and (max-width: 1100px) {
    padding: 16px;
    width: 100%;
}

h2 {
    font-size: 36px;
    font-weight: 700;
    line-height: 45px;
    text-align: ${props => props.textAlignH2 || "center"};
    margin-bottom: ${props => props.mb_h2 || "0"};

    span {
        background:linear-gradient(227deg, #DC4405 0%, #FF8D24 85.6%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    @media screen and (max-width: 1100px) {
        font-size: 24px;  
    }
}

h4 {
font-weight: 600;
font-size: 20px;
line-height: 28px;
text-align: ${props => props.textAlignH4 || "center"};
margin-bottom: ${props => props.mb_h4 || "0"};
}

h5 {
font-weight: ${props => props.fontWeightH5 || "600"};
font-size: 16px;
line-height: 24px;
text-align: ${props => props.textAlignH5 || "left"};
margin-bottom: ${props => props.mb_h5 || "0"};
}

p {
font-weight: 400;
font-size: ${props => props.fontSizeP || "20px"};
line-height: 28px;
text-align: ${props => props.textAlignP || "center"};
margin: 0 auto;
margin-bottom: ${props => props.mb_p || "0"};
width: ${props => props.widthP || "100%"};

@media screen and (max-width: 1100px) {
    width: 100%;
}
span {
    font-weight: 700;
}
.gradient{
    background:linear-gradient(227deg, #DC4405 0%, #FF8D24 85.6%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
}

small {
font-size: 12px;
font-weight: 400;
line-height: 24px;
text-align: ${props => props.textAlignSmall || "left"};
margin-bottom: ${props => props.mb_small || "0"};

span {
    font-weight: 700;
}
}

.flex-wrapper {
    display: flex;
    flex-direction: ${props => props.flexDirection || "column"};
    gap: ${props => props.gap || "5px"};
    align-items: ${props => props.alignItems || "start"};
    justify-content: ${props => props.justifyContent || "start"};
    margin-bottom: ${props => props.mbWrapper || "0"};
}

`

export const HeadingContainer = styled.h2`
font-size: 36px;
font-weight: 700;
line-height: 45px;
text-align: center;

@media screen and (max-width: 1100px) {
    font-size: 24px;
}
span {
    background:linear-gradient(227deg, #DC4405 0%, #FF8D24 85.6%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
`

export const WrapperSmallGap = styled.div`
    display: flex;
    flex-direction: ${props => props.flexDirection || "column"};
    gap: ${props => props.gap || "24px"};
    align-items: ${props => props.alignItems || "start"};
    justify-content: ${props => props.justifyContent || "start"};
    margin-bottom: ${props => props.mbWrapper || "0"};
    width: ${props => props.width || "100%"};
    margin: 0 auto;
    margin-bottom: ${props => props.marginBottom || "0"};

    @media screen and (max-width: 1100px) {
       flex-direction: column;
       width: 100%;
    }

p {
    text-align: ${props => props.textAlignP || "center"};

    span {
        font-weight: 700;
    }
}

img {
    width: ${props => props.imgWidth || "55%"};
    object-fit: cover;
    @media screen and (max-width: 1100px) {
        width: 80%; 
    }
}

`